import { makeStyles } from '@mui/styles';

// Uncomment theme if you need to access the theme's values
export const useWorldClockStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
    },
    container: {
      minWidth: '3.75rem',
      marginRight: '2rem',
      '@media(max-width: 1250px)': {
        marginRight: '1rem',
      },
    },
    countryContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '.5rem',
    },
    countryLabel: {
      fontWeight: 'bold',
      marginBottom: '.25rem',
      color: theme.palette?.mode === 'dark' ? '#fff' : '#222',
      marginTop: '.25rem',
    },
    time: {
      fontWeight: 'bold',
      color: theme.palette?.mode === 'dark' ? '#fff' : '#222',
      paddingLeft: '.6rem',
    },
  }),
  { name: 'HeaderWorldClock' },
);
